module.exports = __webpack_public_path__ + "img/cafe-no-chiado.51e524c6.jpg";